import Vue from 'vue'
import Vuex from 'vuex'

import I18n from 'i18n-js/index.js.erb'
import flatMap from 'lodash-es/flatMap'

import ApplyButton from '../job/apply_button.vue'
import Modal from '../components/modal.vue'
import FilterSummary from '../components/filter_summary.vue'
import FilterSettings from '../components/filter_settings.vue'
import PhdTest from '../phd_test/phd_test.vue'

import SvgIcon from '../components/svg_icon.vue'

import storeConfig from '../store'

import { mapConfig } from '@/webtrekk_tracking/config'

I18n.defaultLocale = global.I18n.defaultLocale
I18n.locale = global.I18n.locale

Vue.component('svg-icon', SvgIcon)

Vue.filter('t', function (value, opts = null) {
  if (!value) return ''
  value = value.toString()
  return I18n.t(value, opts)
})

Vue.directive('tracking-context', {
  bind: (el, binding, _vnode) => {
    el.dataset.acContext = JSON.stringify(mapConfig(binding.value))
  }
})

Vue.directive('click-track', {
  bind: (el, binding, _vnode) => {
    const config = mapConfig(binding.value)
    const handler = () => {
      EventBus.trigger('tracking:vueEventTrack', { el, config })
    }
    el.addEventListener('click', handler)
    // TODO: figure out whether we actually need this (because it keeps the click event above from firing).
    // el.$destroy = () => el.removeEventListener('click', handler)
    // },
    // unbind: (el, _binding, _vnode) => {
    // el.$destroy()
  }
})

Vue.use(Vuex)

const components = { ApplyButton, FilterSettings, FilterSummary, Modal, PhdTest }
const store = new Vuex.Store(storeConfig)

store.replaceState({ ...store.state, ...(global.VuexStore || {}) })

const mountVueComponents = () => {
  Object.entries(components).forEach(([componentName, component]) => {
    const className = `nyx-${componentName}`

    flatMap([...document.getElementsByClassName(className)], el => {
      // Don't mount an element that already belongs to a Vue instance
      if (!el.__vue__) {
        const props = JSON.parse(el.dataset.props || '{}')
        const state = JSON.parse(el.dataset.state || '{}')
        store.replaceState({ ...store.state, ...state })
        // Make sure store is ready before mounting components (mainly to cope with legacy code)
        setTimeout(() => {
          new Vue({ store, el, render: h => h(component, { props }) })
        })
      }
    })
  })
}

EventBus.on('vue:mount', mountVueComponents)

document.addEventListener('DOMContentLoaded', () => {
  mountVueComponents()
})
